<template>
  <v-app>
    <!--    <v-navigation-drawer app right color="white" floating>
      <router-view name="rightDrawer"> </router-view>
    </v-navigation-drawer>-->
    <v-app-bar app color="white" v-if="$route.meta.nav === true">
      <v-spacer />
      <v-btn>
        Login
      </v-btn>
    </v-app-bar>
    <v-main class="white">
      <v-container fluid class="pa-0 fill-height">
        <router-view name="main" />
      </v-container>
      <vue-snotify></vue-snotify>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Wrapper",
  created() {
    this.$vuetify.theme.themes.light.primary = "#0D5AA3";
    this.$vuetify.theme.themes.light.secondary = "#D2DDF1";
  }
};
</script>

<style scoped></style>
